import { useEffect } from "react";

export function GlobalReferralCapture() {
  useEffect(() => {
    try {
      // Get URL search params
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get("ref");
      
      if (ref) {
        localStorage.setItem("referralCode", ref);
        console.log("Stored referralCode:", ref);
      }
    } catch (error) {
      console.error("Error in GlobalReferralCapture:", error);
    }
  }, []);

  return null;
}
